import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import DeleteIcon from '@mui/icons-material/Delete';

import {formatDate,formatTime} from '../../helpers/dates';
import {formatProviderName} from '../../helpers/providers';
import TouchpointIcon from './TouchpointIcon';
import {getTouchpointOptions} from '../../helpers/leads';
import {useRemoveLeadCommentMutation} from '../../redux/services/leadApi';


const handleDeleteComment = ({id, remove}) => async e => {
  const response = await remove(id);
};

const LeadComment = props => {
  const [remove] = useRemoveLeadCommentMutation();
  const onDelete = handleDeleteComment({id: props?.comment?.id, remove});
  return (
    <Box>
      <Stack gap={0.25} padding={0.25}>
        <Typography variant='body1'>
          {props?.comment?.content}
        </Typography>
        <Typography variant='caption' color='text.gray' style={{fontWeight: 'bold'}}>
          {formatProviderName(props?.comment?.author)}
        </Typography>
        <Stack direction='row' spacing={2} alignItems='center' paddingTop={0} marginTop={0}>
          <Typography variant='caption' color='text.gray'>
            {formatDate(props?.comment?.date_created)}{' '}
            {formatTime(props?.comment?.date_created)}
          </Typography>
          <Typography variant='caption' color='text.gray'>
            <Stack direction='row' gap={0.5} alignItems='center'>
              <TouchpointIcon 
                touchpoint={props?.comment?.touchpoint} 
                sx={{ fontSize: '1.1rem' }}
              />
              {getTouchpointOptions().find(opt => opt.value === props?.comment?.touchpoint)?.label}
            </Stack>
          </Typography>
          <IconButton
            onClick={onDelete}
            aria-label='Delete comment'
            size='small'
          >
            <DeleteIcon 
              color='error'
              sx={{fontSize: '1.1rem'}} 
            />
          </IconButton>
        </Stack>
      </Stack>
    </Box>
  );
};

LeadComment.propTypes = {
  comment: PropTypes.object.isRequired,
};

export default LeadComment;